module.exports = __webpack_public_path__ + "static/media/MTL_SL_RUSH3.301e20ee.png";